import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0abb4612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dayProgressBar" }
const _hoisted_2 = {
  class: "emptyBar",
  ref: "emptyBar"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "startBall" }, null, -1))
const _hoisted_4 = { class: "times" }
const _hoisted_5 = { class: "startHour" }
const _hoisted_6 = { class: "endHour" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "currentBar",
        style: _normalizeStyle('width:' + _ctx.progress + 'px')
      }, null, 4),
      _createElementVNode("div", {
        class: "currentBall",
        style: _normalizeStyle('left:' + (_ctx.progress + 10) + 'px')
      }, null, 4)
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.startHour) + ":00 ", 1),
      _createElementVNode("div", {
        class: "currentHour",
        style: _normalizeStyle('left:' + (_ctx.progress) + 'px')
      }, _toDisplayString(_ctx.$filters.date(this.currentTime, "HH:mm")), 5),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.endHour) + ":00 ", 1)
    ])
  ]))
}